import React, { useState, useEffect } from "react"
import images from '../../themes/appImage'
import { Link, useLocation, useNavigate, } from "react-router-dom";
import { Breadcrumb, Button, Modal } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { addEncouragementGroupSuccessHandler, createGroupPostModalHandler, editEncouragementGroupLoad, encouragementRenderPostListLoad, groupCreatePostLoad, toxicGroupPostLoad } from "../../redux/slices/encouragementgroups.slice";
import EncouragementPosts from "./EncouragePost/EncouragementPosts";
import { useFormik } from "formik";
import * as Yup from 'yup';
import appconstant from "../../themes/appconstant";
import { imageURL } from "../../redux/Api/apikit.js";
import { emptySpaceInputHandler } from "../../utils/index.js";

const initialStateCreatePostPayload = {
    text: "",
    postType: "textOnly",
    file: ""

}

const postTypeHandler = (type, text) => {
    if (type === "image/jpeg" || type === "image/png") {
        if (text === "") {
            return "postOnly";
        } else {
            return "imageWithText";
        }
    } else if (type === "video/mp4") {
        if (text === "") {
            return "videoOnly";
        } else {
            return "videoWithText";
        }
    } else if (type === "image/gif") {
        if (text === "") {
            return "gifOnly";
        } else {
            return "textWithGIF";
        }
    } else {
        return "textOnly";
    }
};

const GratitudeAttitude = () => {
    const state = useLocation()
    const [updateGroupImage, setUpdateGroupImage] = useState({
        icon: false,
        image: false
    })

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [modal1Open, setModal1Open] = useState(false)
    const { createPostModal, postCreatedSuccess, addEncouragementGroupSuccess } = useSelector(state => state.EncouragementgroupsReducer)
    const [createPostPayload, setCreatePostPayload] = useState(initialStateCreatePostPayload)

    useEffect(() => {
        if (addEncouragementGroupSuccess) {
            setModal1Open(false)
            setUpdateGroupImage({
                icon: false,
                image: false
            })
            resetFormState()
            dispatch(addEncouragementGroupSuccessHandler())
            navigate("/encouragementgroups")
        }
    }, [addEncouragementGroupSuccess])

    useEffect(() => {
        if (postCreatedSuccess) {

            setCreatePostPayload(initialStateCreatePostPayload)
        }
    }, [postCreatedSuccess])

    const postCreateHandler = () => {
        const form = new FormData()
        const postType = postTypeHandler(uploadFileType, createPostPayload?.text,)
        form.append("text", createPostPayload.text)
        form.append("postType", postType)
        form.append("type", "group")
        form.append("group", state?.state?.groupId || "")
        form.append("file", createPostPayload.file)

        dispatch(toxicGroupPostLoad({
            apiKey : process.env.REACT_APP_API_URL,
            comment : createPostPayload.text,
            form : form
        }
        ))
    }


    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setCreatePostPayload(pre => ({ ...pre, file }))
    };


    const uploadFileType = createPostPayload?.file?.type?.length > 0 ? createPostPayload?.file?.type : undefined

    // F O R M I K  F O R  -- A D D  N E W  O R G A N I Z A T I O N  M O D AL 

    const validationSchema = Yup.object({
        name: Yup.string()
            .required('Please enter group name')
            .max(30, 'Group name must be at most 30 characters'),
        description: Yup.string()
            .required('Please enter group details')
            .min(10, 'Group details must be at least 10 characters')
            .max(500, 'Group details must be at most 500 characters'),
        image: Yup.string().required('Please upload cover image'),
        icon: Yup.string().required('Please upload icon'),
    });

    const formik = useFormik({
        initialValues: {
            name: state?.state?.groupName,
            description: state?.state?.description,
            image: state?.state?.image,
            icon: state?.state?.icon,
        },
        validationSchema,
        onSubmit: (values) => {
            const form = new FormData()
            form.append("name", values.name)
            form.append("description", values.description)
            form.append("image", values.image)
            form.append("icon", values.icon)
            form.append("groupId", state?.state?.groupId)
            dispatch(editEncouragementGroupLoad(form))
        },
    });

    const inputHandler = (event) => {
        let { name } = event.target;
        formik.setFieldValue(name, emptySpaceInputHandler(event));
    };

    const setFormikValue = () => {
        formik.setValues({
            name: state?.state?.groupName,
            description: state?.state?.description,
            image: state?.state?.image,
            icon: state?.state?.icon,
        });
    }

    const resetFormState = () => {
        formik.setValues({
            name: "",
            description: "",
            image: "",
            icon: ""
        });
        formik.setTouched({
            name: null,
            description: null,
            image: null,
            icon: null
        });
    }

    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>
                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Encouragement Groups</h1>
                        <Breadcrumb separator=" > ">
                            <Breadcrumb.Item>
                                <Link to="/encouragementgroups"> Encouragement Groups </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {state.state.groupName}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="add-new-button edit-btn-sec">
                        <button onClick={() => {
                            setFormikValue();
                            setModal1Open(!modal1Open)
                        }}> <span> <img src={images.editPost} alt="editPost" /></span>Edit</button>
                        <button onClick={() => dispatch(createGroupPostModalHandler())} > <span> <img src={images.addSumthing} alt="addSumthing" /></span>Post in {state.state.groupName}</button>
                    </div>
                </div>

                <div className="add-post-dis-mental-fit">
                    <div className="community-page-width">
                        <div className="gratitude-attitude-new-sec">
                            <div className="gratitude-inner-sec">
                                <img
                                    className="w-20 h-20 object-contain"
                                    src={`${imageURL}${state.state.icon}`}
                                    alt="attitudeicon"
                                />
                                <h1 className="w-[100%] overflow-hidden text-wrap">{state.state.groupName}</h1>
                                <p className="w-[100%] overflow-hidden text-wrap">{state.state.description}</p>
                            </div>
                        </div>


                        {/* <div className="user-post community-post-bg ">

                            <div className="post-rmover-setting">
                                <div className="post-disp rmoving-padding-lf">
                                    <div className="user-pofile">
                                        <img src={images.matleFitLogo} alt="userProf" />
                                    </div>
                                    <div className="user-name ">
                                        <h2>MentalFit</h2>
                                        <p>1 hr ago</p>
                                    </div>
                                </div>
                            </div>



                            <div className="user-disp-text">
                                <p>Sometimes we make the process more complicated than we need to. We will never make a journey of a thousand miles.</p>
                            </div>

                            <div className="post-image">
                                <img src={images.post} alt="firstIcon" />
                            </div>

                            <div className=" comment-sec">
                                <div>
                                </div>

                                <div className="like-and-imozes">
                                    <img src={images.commentIcon} alt="commentIcon" />
                                    <img src={images.imozeIcon} alt="imozeIcon" />

                                </div>
                            </div>
                        </div> */}
                        <EncouragementPosts myid={state.state.groupId} />

                    </div>
                </div>
            </div>

            <Modal
                title=""
                className="modal-update create-modal"
                centered
                visible={createPostModal}
                closable={true}
                onCancel={() => {
                    dispatch(createGroupPostModalHandler())
                }}
                footer={false}
                width={600}  >
                <div className="add-user-popup">
                    <div className="modal-add-user create-post-modal">
                        <h1>Create Post</h1>
                    </div>
                    <div className="create-metail-post-modal">
                        <div className="post-disp">
                            <div className="user-pofile">
                                <img src={images.matleFitLogo} alt="userProf" />
                            </div>
                            <div className="user-name">
                                <h2>MentalFit</h2>
                            </div>
                        </div>
                        <div className="input-text-field mb-10 mt-5">
                            <input type="text"
                                value={createPostPayload.text}
                                onChange={(e) => {
                                    const passString = emptySpaceInputHandler(e)
                                    if (passString !== false) {
                                        setCreatePostPayload(pre => ({ ...pre, text: passString }))
                                    }
                                }
                                }
                                placeholder="Write something lorem ipsum..."
                            />
                        </div>
                        <div className="upload-post-sec">
                            <div className="click-to-upload relative">
                                {uploadFileType !== undefined && <div onClick={() => setCreatePostPayload(pre => ({ ...pre, file: "" }))} className="bg-white cursor-pointer p-2 w-5 h-5 absolute -right-3 -top-3 border border-black rounded-full flex justify-center items-center">x</div>}
                                <div className="upload-file new-up-file ">
                                    {uploadFileType !== undefined && uploadFileType == "video/mp4" ?
                                        <video controls style={{ maxWidth: '100%', height: 'auto' }}>
                                            <source src={URL.createObjectURL(createPostPayload.file)} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video> : uploadFileType !== undefined ?
                                            <img src={URL.createObjectURL(createPostPayload.file)} alt="upload" /> : null}
                                    {uploadFileType == undefined && <>
                                        <div className="upload-center-text">
                                            <label htmlFor="fileUpload">
                                                <p>
                                                    <span>
                                                        <img src={images.upload} alt="upload" />
                                                    </span>{" "}
                                                    Click here to upload
                                                </p>
                                            </label>
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                style={{ display: "none" }}
                                                onChange={handleFileUpload}
                                            />
                                        </div>
                                        <p className="image-disp">File Format: .JPEG, .PNG, MP4</p>
                                    </>}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="create-post-comm modal-bott-section">
                        <div className="opacity-0">
                            <img src={images.camera} alt="camera" />
                        </div>
                        <Button
                            disabled={createPostPayload.text.length == 0}
                            loading={false} onClick={postCreateHandler}
                            style={createPostPayload?.text?.length > 0 ? {
                                minWidth: "70px",
                                height: "36px",
                                display: "flex",
                                padding: "6px",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#7c63a4", color: "white"
                            } : {
                                minWidth: "70px",
                                height: "36px",
                                display: "flex",
                                padding: "6px",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#7c63a4", color: "white"
                            }}>Post</Button>
                    </div>


                </div>
            </Modal>
            <Modal
                title=""
                className="modal-update"
                centered
                visible={modal1Open}
                closable={true}
                onCancel={() => {
                    setModal1Open(false)
                    resetFormState()
                }}
                footer={false}
                width={600}  >
                <div className="add-user-popup">

                    <div className="modal-add-user">
                        <h1>Edit Encouragement Group</h1>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="description-inner-circle " >
                            <div className="wrapper_line">
                                <div className="form-group">
                                    <label>{appconstant.enGroupTitle}</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        placeholder='Enter Encouragement Group'
                                        name='name'
                                        value={formik.values.name}
                                        onChange={inputHandler}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.name}</div>
                                    ) : null}
                                </div>

                                <div className="form-group">
                                    <div className="textarea-label">
                                        <label>{appconstant.enGroupDetail}</label>
                                        <p>{formik.values.description.length}/500</p>
                                    </div>
                                    <textarea
                                        rows="5"
                                        cols="50"
                                        className='form-control-textarea'
                                        type='textarea'
                                        placeholder='Enter details here'
                                        name='description'
                                        value={formik.values.description}
                                        onChange={(e) => {
                                            const getStringLength = e.target.value.length
                                            if (getStringLength <= 500) {
                                                inputHandler(e)
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.description && formik.errors.description ? (
                                        <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.description}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        <div className="add-sugg-activity"
                            style={{ marginTop: "59px" }}
                        >
                            <div className="click-to-upload label-top-space">
                                <label >Upload Cover</label>
                                {formik?.values?.image ?
                                    <div className="w-[30%]  relative">
                                        <div onClick={() => {
                                            setUpdateGroupImage({ icon: updateGroupImage.icon, image: true })
                                            formik.setFieldValue("image", "")
                                        }} className="bg-white w-4 h-4 cursor-pointer absolute -right-3 -top-2 border border-black rounded-full flex justify-center items-center">
                                            <img className="w-[60%] h-[60%] rounded-full object-contain" src={images.crossIcon} />
                                        </div>
                                        {updateGroupImage.image ? <img className="h-20 w-full object-contain mt-2 mb-5" src={URL.createObjectURL(formik.values.image)} alt="upload" /> : <img className="h-20 w-full object-contain mt-2 mb-5" src={`${imageURL}${formik?.values?.image}`} alt="upload" />}
                                    </div>
                                    : <>
                                        <label className="cursor-pointer" htmlFor="uploadCoverPic">
                                            <div className="upload-file new-up-file label-less-margin">
                                                <div className="upload-center-text add-up-activity">
                                                    <p ><span><img src={images.upload} alt="upload" /></span>Click here to upload</p>
                                                </div>
                                                <p className="image-disp">File Format: .JPEG, .PNG</p>
                                            </div>
                                        </label>
                                        {formik.touched.image && formik.errors.image ? (
                                            <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.image}</div>
                                        ) : null}
                                        <input
                                            type="file"
                                            id="uploadCoverPic"
                                            style={{ display: "none" }}
                                            onChange={(e) => formik.setFieldValue("image", e.target.files[0])}
                                        // onChange={(e) => uploadFileHandler("uploadCoverPic", e)}
                                        />
                                    </>}
                            </div>

                            <div className="upload-icons-text">
                                <label>Upload Icon</label>

                                {formik?.values?.icon ?
                                    <div className="w-[30%]  relative">
                                        <div onClick={() => {
                                            setUpdateGroupImage({ icon: true, image: updateGroupImage.image })
                                            formik.setFieldValue("icon", "")

                                        }} className="bg-white w-4 h-4 cursor-pointer absolute -right-3 -top-2 border border-black rounded-full flex justify-center items-center">
                                            <img className="w-[60%] h-[60%] rounded-full object-contain" src={images.crossIcon} />
                                        </div>
                                        {updateGroupImage.icon ? <img className="h-20 w-full mt-2 object-contain mb-5" src={URL.createObjectURL(formik?.values?.icon)} alt="upload" /> : <img className="h-20 w-full object-contain mt-2 mb-5" src={`${imageURL}${formik?.values?.icon}`} alt="upload" />}
                                    </div>
                                    :
                                    <label className="cursor-pointer" htmlFor="uploadLogo">
                                        <div className="click-here-to-up">
                                            <p>Click here to upload icon</p>
                                            <img src={images.upload} alt="upload" />
                                        </div>
                                        {formik.touched.icon && formik.errors.icon ? (
                                            <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.icon}</div>
                                        ) : null}
                                        <input
                                            type="file"
                                            id="uploadLogo"
                                            style={{ display: "none" }}
                                            onChange={(e) => formik.setFieldValue("icon", e.target.files[0])}
                                        />
                                    </label>}
                            </div>
                        </div>

                        <div className="click-to-upload">
                            <div className="add-activity-button add-space-group">
                                <button type="submit" >Add Encouragement Group</button>
                            </div>
                        </div>
                    </form>

                </div>
            </Modal >



        </div >
    )
}
export default GratitudeAttitude

